export const financialInfoConstants = {
    LOAD_FINANCIAL_INFO_SUCCESS: 'LOAD_FINANCIAL_INFO_SUCCESS',
    SAVE_FINANCIAL_INFO_SUCCESS: 'SAVE_FINANCIAL_INFO_SUCCESS',
    EDIT_FINANCIAL_INFO_UPDATE: 'EDIT_FINANCIAL_INFO_UPDATE',
    GENERIC_FAILURE : 'PROFILE:GENERIC_FAILURE',
    ADD_FINANCIAL_SUCCESS :"ADD_FINANCIAL_SUCCESS",
    UPDATE_FINANCIAL_SUCCESS :"UPDATE_FINANCIAL_SUCCESS",
    REMOVE_FINANCIAL_SUCCESS :"REMOVE_FINANCIAL_SUCCESS",
    ADD_EMPLOYER_SUCCESS: 'ADD_EMPLOYER_SUCCESS',
    UPDATE_EMPLOYER_SUCCESS: 'UPDATE_EMPLOYER_SUCCESS',
    REMOVE_EMPLOYER_SUCCESS: 'REMOVE_EMPLOYER_SUCCESS',
    ADD_INCOME_SUCCESS: 'ADD_INCOME_SUCCESS',
    UPDATE_INCOME_SUCCESS: 'UPDATE_INCOME_SUCCESS',
    REMOVE_INCOME_SUCCESS: 'REMOVE_INCOME_SUCCESS',
    LOAD_FINANCIALS_FROM_SESSION_SUCCESS: 'LOAD_FINANCIALS_FROM_SESSION_SUCCESS',
    FINANCIAL_INFO_FORM_OPEN: 'FINANCIAL_INFO_FORM_OPEN',
    FINANCIAL_INFO_FORM_CLOSE: 'FINANCIAL_INFO_FORM_CLOSE',
};



// WEBPACK FOOTER //
// ./src/_constants/financialInfo.constants.js